import { safeDefine } from "../../registration/safe-define.js";
import { CompatLiveVideoSkinElement } from "../../presets/live-video/compat-skin.js";
import "../../internal/skins/compat-live-video/register.js";
//#region src/define/live-video/compat-skin.ts
safeDefine(CompatLiveVideoSkinElement);
//#endregion

//# sourceMappingURL=compat-skin.js.map